import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  other: {
    paddingBottom: ({ hasQuickLinks }) => (hasQuickLinks ? theme.spacing(8) : 0),
  },
  img: {
    margin: '0 auto',
    display: 'block',
    maxWidth: '100%',
  },
}))

export default useStyles
